import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/admin/login", { email, password });
      localStorage.setItem("bm_admin_token", r.data.token);
      navigate("/admin");
    } catch { toast.error("Invalid credentials"); }
    setLoading(false);
  };

  return (
    <section className="min-h-screen flex items-center justify-center bg-[#f9f9f9] px-4" data-testid="admin-login">
      <form onSubmit={submit} className="card-soft p-10 max-w-sm w-full">
        <div className="font-serif-bm text-2xl tracking-[0.25em] text-center">BOOM MODE</div>
        <h1 className="font-serif-bm text-2xl mt-6">Admin Login</h1>
        <p className="text-xs text-[var(--bm-muted)] mt-1">Sign in to manage products and orders.</p>
        <input className="bm-input mt-6" type="email" placeholder="Email" value={email} onChange={e=>setEmail(e.target.value)} required data-testid="admin-email"/>
        <input className="bm-input mt-3" type="password" placeholder="Password" value={password} onChange={e=>setPassword(e.target.value)} required data-testid="admin-password"/>
        <button className="btn-primary w-full justify-center mt-5" disabled={loading} data-testid="admin-login-btn">{loading ? "Signing in…" : "Sign in"}</button>
      </form>
    </section>
  );
}
